module.exports = __webpack_public_path__ + "img/banner-principal.1c6c841f.png";